import React from "react";
import MapGoogle from "../../../components/mapsGoogle/MapGoogle";
import useInTheWorld from "../../../hooks/useInTheWorld";
import useMaps from "../../../hooks/useMaps";

function InTheWorldReplica() {
  const {
    markersInTheWorld,
    centerInTheWorldMedium,
    centerInTheWorldSmall,
    warehouseListInTheWorld
  } = useMaps();

  const { inTheWorld } = useInTheWorld();

  const newArray = {
    ...inTheWorld,
    locations: inTheWorld?.locations?.sort(function (o1, o2) {
      if (o1.country > o2.country) {
        //comparación lexicogŕafica
        return 1;
      } else if (o1.country < o2.country) {
        return -1;
      }
      return 0;
    })
  };

  return (
    <div id="blur-prueba">
      <div className="botton-editar-pginews margin-boton-world">
        <button className=" settings_button-pleno overlay-replica-button">
          {" "}
          <a href="/pgi/edit-intheworld">Editar Sección In The World</a>
        </button>
      </div>

      <div id="intheWorld" className="bg-fullpage">
        {/* <img src={fondo} alt="" /> */}
        <MapGoogle
          markers={inTheWorld ? inTheWorld?.locations : ""}
          center={window.innerWidth < 575 ? centerInTheWorldSmall : centerInTheWorldMedium}
          zoom={3}
          data={newArray}
        />

        {/* <div className="card-info" >
          <div className="cuadrado-azul"></div>
          <h1>"We are an innovative organization based in Argentina for de world"</h1>
        </div> */}
        <section className="container halfintro">
          <div className="card-info col-12 col-xl-7 col-lg-7 col-md-6 col-sm-12">
            <div className="cuadrado-azul"></div>
            <h1 className="text-world">{inTheWorld?.title}</h1>
          </div>
          <div id="locations-intro" className="card-info col-12 col-xl-7 col-lg-7 mt-1">
            {newArray?.locations?.map((loc, index) => (
              <div key={index} className="intheWorld__locations d-flex">
                {loc?.country === "Argentina" && index !== 0 ? (
                  <h2 className="col-3"> </h2>
                ) : loc?.country === "Argentina" && index === 0 ? (
                  <h2 className="col-3">{loc?.country}</h2>
                ) : (
                  <h2 className="col-3">{loc?.country}</h2>
                )}
                <ul>
                  <h3>{loc?.province}</h3>
                  <li>{loc?.phone}</li>
                  <li>
                    {loc?.address} <br />
                    {loc?.postal_code} {loc?.locality}, {loc?.province}
                  </li>
                  <li>{loc?.email}</li>
                </ul>
              </div>
            ))}
            {/* <div className="intheWorld__locations d-flex">
              <h2 className="col-3">Paraguay</h2>
              <ul>
                <h3>Asunción</h3>
                <li> +54 381 437 2215</li>
                <li>
                  Aviadores del Chaco 2581 <br />
                  Asunción 1411, Paraguay
                </li>
                <li>comunicaciones@tensolite.com</li>
              </ul>
            </div>
            <div className="intheWorld__locations d-flex">
              <h2 className="col-3">Uruguay</h2>
              <ul>
                <h3>Montevideo</h3>
                <li> 2359 2526 / 2355 8201 / 2355 8298</li>
                <li>
                  Bvar. Batlle y Ordóñez 5840 <br />
                  Montevideo 12300, Uruguay
                </li>
                <li>hopresa@hopresa.com.uy</li>
                <li>ventas@hopresa.com.uy</li>
              </ul>
            </div>
            <div className="intheWorld__locations d-flex">
              <h2 className="col-3">United States</h2>
              <ul>
                <h3>Miami</h3>
                <li>+1 305-273-0625</li>
                <li>
                  444 Brickell Ave. 81 SE 5th St
                  <br />
                  Miami, FL 33176, Estados Unidos
                </li>
                <li>comunicaciones@tensolite.com</li>
              </ul>
            </div> */}
          </div>
        </section>
      </div>
      {/* seccion inferior */}
      {/*seccton visible a partir de 1200 px */}
      <section className="intheWorld__locations-botton">
        <div className="container">
          <div className="intheWorld__locations mt-5">
            {newArray?.locations?.map((loc, index) => (
              <div key={index} className="intheWorld__locations d-flex">
                {loc?.country === "Argentina" && index !== 0 ? (
                  <h2 className="col-3"> </h2>
                ) : loc?.country === "Argentina" && index === 0 ? (
                  <h2 className="col-3">{loc?.country}</h2>
                ) : (
                  <h2 className="col-3">{loc?.country}</h2>
                )}
                <ul>
                  <h3>{loc?.province}</h3>
                  <li>{loc?.phone}</li>
                  <li>
                    {loc?.address} <br />
                    {loc?.postal_code} {loc?.locality}, {loc?.province}
                  </li>
                  <li>{loc?.email}</li>
                </ul>
              </div>
            ))}
          </div>
          {/* <div className="intheWorld__locations">
            <h2 className="col-md-2 col-lg-4">Paraguay</h2>
            <ul className="col-md-5 col-lg-4">
              <h3>Asunción</h3>
              <li> +54 381 437 2215</li>
              <li>
                Aviadores del Chaco 2581 <br />
                Asunción 1411, Paraguay
              </li>
              <li>comunicaciones@tensolite.com</li>
            </ul>
          </div>
          <div className="intheWorld__locations">
            <h2 className="col-md-2 col-lg-4">Uruguay</h2>
            <ul className="col-md-5 col-lg-4">
              <h3>Montevideo</h3>
              <li> 2359 2526 / 2355 8201 / 2355 8298</li>
              <li>
                Bvar. Batlle y Ordóñez 5840 <br />
                Montevideo 12300, Uruguay
              </li>
              <li>hopresa@hopresa.com.uy</li>
              <li>ventas@hopresa.com.uy</li>
            </ul>
          </div>
          <div className="intheWorld__locations">
            <h2 className="col-md-2 col-lg-4">United States</h2>
            <ul className="col-md-5 col-lg-4">
              <h3>Miami</h3>
              <li>+1 305-273-0625</li>
              <li>
                444 Brickell Ave. 81 SE 5th St
                <br />
                Miami, FL 33176, Estados Unidos
              </li>
              <li>comunicaciones@tensolite.com</li>
            </ul>
          </div> */}
        </div>
      </section>
    </div>
  );
}

export default InTheWorldReplica;
